export const CACHE_KEY_LIST_NOMENCLATURES_AREA_TYPE = 'nomenclatures-area-type';
export const CACHE_KEY_NOMENCLATURES_AREA_TYPE = 'nomenclatures-area-type-one';
export const ROUTE_PATH_NOMENCLATURES_AREA_TYPE = '/settings/nomenclatures/area-type';
export const TRANSLATION_PREFIX_NOMENCLATURES_AREA_TYPE = 'nomenclaturesAreaType';

